import useTranslations from './useTranslations';
export {default as TranslationsContext} from './TranslationsContext';
export {default as languages} from './languages';

export default useTranslations;